import CityPageTemplate from "../city-template/CityPageTemplate";
import { mercedConfig } from "./data";

export default function MercedPage() {
  return <CityPageTemplate config={mercedConfig} />;
}